import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api-graphql";
import { Amplify, Auth, API } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { PuffLoader } from "react-spinners";

import { AWS_CONFIG } from "../../../aws-config";
import {
  QueryAskPCOSUsersByUserSubIndexQuery,
  QueryAskPCOSUsersByUserSubIndexQueryVariables,
} from "../../api/graphql/API";
import { queryAskPCOSUsersByUserSubIndex } from "../../graphql/queries";
import ErrorText from "../ErrorText";
import { AskPCOSUserType } from "../types";
import getProfileFromSessionStorage from "./getProfileFromSessionStorage";
import syncProfileWithSessionStorage from "./syncProfileWithSessionStorage";

const QueryUserProfile: React.FC<{
  children: (data: AskPCOSUserType[] | null) => any;
  fallBackChildren?: (error: string | null) => any;
  hideLoader?: boolean;
}> = ({ children, fallBackChildren, hideLoader }) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<AskPCOSUserType[] | null>(null);

  const fetchUserProfile = async (user_sub: string) => {
    console.log("Fetching data from remote source");
    try {
      //console.log("Fetching data from remote source")
      const data = (await API.graphql({
        query: queryAskPCOSUsersByUserSubIndex,
        variables: {
          user_sub: user_sub,
          first: 10,
        } as QueryAskPCOSUsersByUserSubIndexQueryVariables,
        authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
      })) as { data: QueryAskPCOSUsersByUserSubIndexQuery };
      console.log("what", data.data.queryAskPCOSUsersByUserSubIndex);
      console.log(
        "user profile",
        data.data.queryAskPCOSUsersByUserSubIndex?.items
      );
      console.log(
        "Type of items : ",
        typeof data.data.queryAskPCOSUsersByUserSubIndex?.items
      );
      console.log("Type of data : ", typeof data);

      if (!data.data.queryAskPCOSUsersByUserSubIndex) {
        setLoading(false);
        setError("Could not load data");
        return;
      }
      setData(data.data.queryAskPCOSUsersByUserSubIndex.items!);
      if (
        data.data.queryAskPCOSUsersByUserSubIndex.items &&
        data.data.queryAskPCOSUsersByUserSubIndex.items.length
      ) {
        syncProfileWithSessionStorage(
          data.data.queryAskPCOSUsersByUserSubIndex.items[0]
        );
      }
      setLoading(false);
    } catch (e) {
      setError(JSON.stringify(e));
      setLoading(false);
    }
  };

  useEffect(() => {
    Amplify.configure(AWS_CONFIG);

    Auth.currentAuthenticatedUser()
      .then(data => {
        const userProfileDataFromLocalStorage = getProfileFromSessionStorage();
        if (!userProfileDataFromLocalStorage) {
          fetchUserProfile(data.attributes.sub);
          return;
        }
        const parsedUserProfileData: AskPCOSUserType = JSON.parse(
          userProfileDataFromLocalStorage
        );
        if (!parsedUserProfileData) {
          fetchUserProfile(data.attributes.sub);
          return;
        }
        if (parsedUserProfileData.user_sub !== data.attributes.sub) {
          fetchUserProfile(data.attributes.sub);
          return;
        }
        //console.log("Fetching data form local store")
        setData([parsedUserProfileData]);
        setLoading(false);
      })
      .catch(error => {
        console.error(error);
        setError(error);
      });
  }, []);

  if (error) {
    if (fallBackChildren) return <>{fallBackChildren(error)}</>;
    return (
      <div className="flex items-center justify-center my-20">
        <div style={{ maxWidth: "300px" }}>
          <ErrorText text={error} />
        </div>
      </div>
    );
  }
  console.log("loading", loading);
  if (loading && !hideLoader)
    return (
      <div className="flex items-center justify-center my-20">
        <div>
          <div className="flex items-center justify-center">
            <PuffLoader size={35} color="#003b78" />
          </div>
          <p className="py-2 px-4 bg-gray-200 text-gray-700 rounded-full mt-3 leading-none text-xs">
            Loading...
          </p>
        </div>
      </div>
    );
  if (loading && hideLoader) return <></>;
  return <>{children(data)}</>;
};

export default QueryUserProfile;
